export function truncateText(value = "", max = 180) {
  const clean = String(value || "")
    .replace(/\s+/g, " ")
    .trim();

  if (clean.length <= max) return clean;

  return `${clean.slice(0, max - 1)}…`;
}

export function formatDateTime(value) {
  if (!value) return "Date inconnue";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "Date inconnue";

  return date.toLocaleString("fr-FR", {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function formatShortDate(value) {
  if (!value) return "—";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function buildMediaAlbumSearchParams({
  q,
  activeFilter,
  homeFilter,
  page,
  limit,
}) {
  return {
    q: q?.trim() || undefined,
    is_active:
      activeFilter === "all"
        ? undefined
        : activeFilter === "active"
          ? true
          : false,
    show_on_home:
      homeFilter === "all"
        ? undefined
        : homeFilter === "home"
          ? true
          : false,
    page,
    limit,
    sort: "display_order",
    dir: "ASC",
  };
}

export function normalizeMediaAlbumForm(form) {
  return {
    title: form.title.trim(),
    slug: form.slug?.trim() || undefined,
    description: form.description?.trim() || null,
    is_active: !!form.is_active,
    is_public: !!form.is_public,
    show_on_home: !!form.show_on_home,
    display_order: Number(form.display_order || 0),
  };
}

export function validateMediaAlbumForm(form) {
  const errors = {};

  if (!form.title?.trim()) {
    errors.title = "Le titre de l’album est obligatoire.";
  }

  if (form.display_order !== "" && Number.isNaN(Number(form.display_order))) {
    errors.display_order = "L’ordre doit être un nombre.";
  }

  return errors;
}

export function getMediaAlbumStats(items = [], total = 0) {
  const activeOnPage = items.filter((item) => !!item.is_active).length;
  const publicOnPage = items.filter((item) => !!item.is_public).length;
  const homeOnPage = items.filter((item) => !!item.show_on_home).length;
  const photosOnPage = items.reduce((sum, item) => {
    return sum + Number(item.total_items || item.items?.length || 0);
  }, 0);

  return {
    total,
    activeOnPage,
    publicOnPage,
    homeOnPage,
    photosOnPage,
  };
}

export function getAlbumStatusLabel(album) {
  if (!album?.is_active) return "Masqué";
  if (!album?.is_public) return "Privé";
  if (album?.show_on_home) return "Accueil";
  return "Public";
}

export function getAlbumStatusClassName(album) {
  if (!album?.is_active) {
    return "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300";
  }

  if (!album?.is_public) {
    return "border-slate-200 bg-slate-100 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300";
  }

  if (album?.show_on_home) {
    return "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-300";
  }

  return "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300";
}

export function moveArrayItem(items = [], fromIndex, toIndex) {
  const list = [...items];

  if (fromIndex === toIndex) return list;
  if (fromIndex < 0 || toIndex < 0) return list;
  if (fromIndex >= list.length || toIndex >= list.length) return list;

  const [removed] = list.splice(fromIndex, 1);
  list.splice(toIndex, 0, removed);

  return list;
}